// Module
var code = "<div class=\"embed-instagram embed-iframe\"> <div class=\"iframe\"> <iframe width=\"{{width}}\" height=\"{{height}}\" src=\"{{embed}}\" frameborder=\"0\" scrolling=\"no\" allowtransparency=\"true\"></iframe> </div> {{#caption}} <p class=\"caption\">{{caption}}</p> {{/caption}} </div> ";
// Exports
export default code;